import { api } from "@/lib/axios";

export interface CheckInData {
  clientCode: string;
  notes?: string;
}

export interface CreateOrderData {
  tableId: string;
  clientId?: string;
  clientName?: string;
  notes?: string;
}

export interface AddItemData {
  productId: string;
  quantity: number;
  notes?: string;
}

export interface CloseOrderData {
  paymentMethod: string;
  discount?: number;
  serviceCharge?: number;
}

export interface TransferOrderData {
  newTableId: string;
}

export const internalOrdersService = {
  // Check-in
  checkIn: async (data: CheckInData) => {
    const response = await api.post("/internal-orders/check-in", data);
    return response.data;
  },

  getRecentCheckIns: async (limit = 50) => {
    const response = await api.get(`/internal-orders/check-ins/recent?limit=${limit}`);
    return response.data;
  },

  // Comandas
  create: async (data: CreateOrderData) => {
    const response = await api.post("/internal-orders", data);
    return response.data;
  },

  getAll: async (status?: string) => {
    const params = status ? `?status=${status}` : "";
    const response = await api.get(`/internal-orders${params}`);
    return response.data;
  },

  getByTable: async (tableId: string, status?: string) => {
    const params = status ? `?status=${status}` : "";
    const response = await api.get(`/internal-orders/table/${tableId}${params}`);
    return response.data;
  },

  getOne: async (id: string) => {
    const response = await api.get(`/internal-orders/${id}`);
    return response.data;
  },

  // Itens
  addItem: async (orderId: string, data: AddItemData) => {
    const response = await api.post(`/internal-orders/${orderId}/items`, data);
    return response.data;
  },

  removeItem: async (orderId: string, itemId: string) => {
    const response = await api.delete(`/internal-orders/${orderId}/items/${itemId}`);
    return response.data;
  },

  // Operações
  closeOrder: async (orderId: string, data: CloseOrderData) => {
    const response = await api.patch(`/internal-orders/${orderId}/close`, data);
    return response.data;
  },

  transferOrder: async (orderId: string, data: TransferOrderData) => {
    const response = await api.patch(`/internal-orders/${orderId}/transfer`, data);
    return response.data;
  },
};
